export const generateRandomString = (length = 3)=> {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let result = '';
    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        result += characters[randomIndex];
    }
    return result;
}

export const versionCheck = (target) => {
    const version = window.localStorage?.app_version ?? '';
    if(!version){
        return false;
    }
    const versionParts = version.split('.').map(Number);

    const targetParts = target.split('.').map(Number);

    for (let i = 0; i < Math.max(versionParts.length, targetParts.length); i++) {
        const v = versionParts[i] || 0; // Use 0 if a part is missing
        const t = targetParts[i] || 0;

        if (v > t) return true;  // Version is greater
        if (v < t) return false; // Version is less
    }

    return true; // Versions are equal
}